import React from 'react'
import { SelectOption } from '../inputs/StandardSelect';
import TabButton from './TabButton';

type Props = {
    selectedValue: string;
    setSelectedValue: (value: string) => void;
    tabs: SelectOption[];
}

const TabPanel = (props: Props) => {
    return (
        <div className="bg-primary-dark flex px-1 overflow-x-auto no-scrollbar">
            {props.tabs.map(tab => {
                return <TabButton
                    key={tab.value}
                    label={tab.label}
                    onClick={() => props.setSelectedValue(tab.value)}
                    selected={props.selectedValue === tab.value}
                />
            })}
        </div>
    )
}

export default TabPanel